/**
 * Created by adalto on 11/14/14.
 * Classe responsável pelos eventos de ordenação dos stops
 *
 */


Greenmile.Route = Greenmile.Route || {};
Greenmile.Route.TransferStops = Greenmile.Route.TransferStops || {};

Greenmile.Route.TransferStops.EventsToSort = function () {

    var divNoStop = function () {

        var div      = document.createElement("div"),
            resource = "Route.TransferStops.message.noStops";

        div.innerHTML = Monet.I18n.getResourcesByKey(resource);
        div.setAttribute("id", "noStop");

        return div;

    };

    var divRouteSearchedInformation = function (contentDiv) {

        var div = document.createElement("div");

        div.innerHTML = contentDiv;

        return div;

    };

    var updateListStops = (function (scope) {

        return function (selector, data) {
            scope.addStopsToList(selector, data);
        };

    }(this));

    var clearListOnBestInsertion = function () {

        var parentElement = document.querySelector("#bestInsertion");

        var liCollection = parentElement.querySelectorAll("#bestInsertion li");
        var liCollectionLength = liCollection.length;

        for (var i = 0; i < liCollectionLength; i++) {

            parentElement.removeChild(liCollection[i]);

        }

        parentElement.style.background = "";

    };

    var clearRouteItemsSelected = function (selector) {

        var items       = null,
            itemsLength = 0;

        if (selector) {

            items = document.querySelectorAll(selector + " .selected");
            itemsLength = items.length;

            for (var i = 0; i < itemsLength; i++) {
                items[i].setAttribute("class", "");
            }

        }

    };

    this.setElementToSortable = function (selector) {

        if (selector) {

            $(selector).sortable({
                connectWith: ".stopSourceConnect",
                over: function () {

                    var parentSelector = null;
                    var divNoStops = document.querySelector("#noStop");

                    if (divNoStops) {
                        parentSelector = divNoStops.parentNode;
                        parentSelector.removeChild(divNoStops);
                    }
                },
                items: "> li"
            });

            $(selector).sortable("enable");

            $("ol.ui-sortable").multisortable({
                receive: function (event, ui) {

                    var parentSelector = ui.item.parent()[0];
                    var selector = "#" + parentSelector.getAttribute("id");

                    if (selector !== "#bestInsertion") {

                        Greenmile.Route.ControlSortable.receiveWasExecuted = true;

                    } else {

                        Greenmile.Route.ControlSortable.receiveBestInsertionWasExecuted = true;
                        Greenmile.Route.ControlSortable.sender = "#" + ui.sender[0].id;

                    }

                },
                stop: (function (scope) {
                    return function (event, ui) {

                        var parentSelector = ui.item.parent()[0];
                        var selector = "#" + parentSelector.getAttribute("id");

                        if (Greenmile.Route.ControlSortable) {

                            if (Greenmile.Route.ControlSortable.receiveWasExecuted) {

                                scope.getDataAndTransferStops(selector, updateListStops);

                                Greenmile.Route.ControlSortable.receiveWasExecuted = false;

                            } else if (Greenmile.Route.ControlSortable.receiveBestInsertionWasExecuted) {

                                var bestInsertionSender = Greenmile.Route.ControlSortable.sender;

                                scope.getDataAndTransferStops(selector, updateListStops, bestInsertionSender);

                                Greenmile.Route.ControlSortable.receiveBestInsertionWasExecuted = false;
                                Greenmile.Route.ControlSortable.sender = "";

                                clearListOnBestInsertion();

                            } else {

                                var routeId = parentSelector.getAttribute("identity");

                                scope.getStopsAndResequence(selector, routeId, updateListStops);

                            }
                        }
                    };

                }(this))

            });

            $(selector + " li").on("click", function () {

                var selectorToClear = "#stopsRouteFiltered";

                if (selector === "#stopsRouteFiltered") {
                    selectorToClear = "#stopsRouteSelected";
                }

                clearRouteItemsSelected(selectorToClear);

            });
        }
    };

    this.removeElementToSortable = function (selector) {

        var error = null;

        try {

            var element = document.querySelector(selector);
            var ol = element.getAttribute("class");

            if (ol.indexOf("ui-sortable") !== -1) {
                $(selector).sortable("disable");
                $("#bestInsertion").sortable("disable");
            }

        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                "Error remove sortable of element.");
            error.console();

        }

    };

    this.addStopsToList = (selector, route) => {
        var error = null;

        if (selector) {

            try {

                var ol = document.querySelector(selector);
                var titleRouteKey = document.querySelector(".transferStop_titleRoutePrincipal");
                var titleRouteKeySearched = document.querySelector(".transferStop_titleRouteSearched");
                var contentToDiv = null;


                ol.innerHTML = "";

                if (route) {

                    if (route.key) {
                        var dateField = new Monet.UI.Fields.DateField();
                        dateField.setValue(route.date);

                        var routeIdentifier = Monet.I18n.getResourcesByKey("stop.route") + ": " + route.key + " - " +
                            Monet.I18n.getResourcesByKey("route.date") + ": " +
                            Monet.Format.Date.formatToLocale(route.date);

                        if (selector.indexOf('RouteSelected') !== -1) {
                            titleRouteKey.innerHTML = routeIdentifier;
                        } else {
                            titleRouteKeySearched.innerHTML = routeIdentifier;
                        }
                    }

                    //valida se a rota pesquisada é igual a selecionada
                    if (selector === "#stopsRouteFiltered") {

                        var routeIdSelected = document.querySelector("#stopsRouteSelected").getAttribute("identity");
                        var routeIdFiltered = route.id;

                        if (parseInt(routeIdSelected) === routeIdFiltered) {

                            var errorMessage = "Route.TransferStops.message.routeIsEqualsSearched";

                            contentToDiv = Monet.I18n.getResourcesByKey(errorMessage);

                            ol.appendChild(divRouteSearchedInformation(contentToDiv));

                            this.removeElementToSortable(selector);

                            return true;

                        } else {
                            this.enableBestInsertion();
                        }
                    }

                    if (route.status !== "COMPLETED") {

                        ol.setAttribute("identity", route.id);

                        if (route.stops) {

                            var stops = route.stops;
                            var stopsLength = stops.length;

                            var docfrag = document.createDocumentFragment();
                            var z = 0;

                            for (var i = 0; i < stopsLength; i++) {

                                var stop = stops[i];

                                if (!stop.actualArrival && !stop.canceled) {

                                    var li = document.createElement("li");

                                    var location = stop.location;

                                    var key = stop.id;
                                    var description = Monet.I18n.getResourcesByKey("EventNotification.noLocationFound");
                                    if (location) {
                                        key = location.key;
                                        description = location.description;
                                    }

                                    li.setAttribute("identity", stop.id);
                                    li.setAttribute("originPosition", z);

                                    li.innerHTML = `<span class='stopKey'>${key}</span>
                                                    <span class='locationDescription'>${description}</span>
                                                    <span id='${stop.id}' class='deleteItemStop table-action-destroylink' style='float: right'></span>`;

                                    docfrag.appendChild(li);

                                    z++;

                                }

                            }

                            if (stopsLength) {
                                ol.appendChild(docfrag);
                            } else {
                                ol.appendChild(divNoStop());
                            }

                        } else {

                            ol.appendChild(divNoStop());

                        }

                        this.setElementToSortable(selector);
                        this.setDeleteEventListener(selector);

                    } else {

                        contentToDiv = Monet.I18n.getResourcesByKey("Route.TransferStops.message.routeIsCompleted");

                        ol.appendChild(divRouteSearchedInformation(contentToDiv));

                        this.removeElementToSortable(selector);

                    }

                } else {

                    contentToDiv = Monet.I18n.getResourcesByKey("Route.TransferStops.message.noRouteFound");

                    ol.appendChild(divRouteSearchedInformation(contentToDiv));
                    ol.setAttribute("identity", "");

                    this.removeElementToSortable(selector);

                }

            } catch (e) {

                error = new Monet.Exception.ReturnError(this, "Error add stops to list");
                error.console();

            }

        }

    };

    this.setDeleteEventListener = (selector) => {
      if (selector) {
        $(`${selector} li .deleteItemStop`).on("click", (event) => {

          const confirmDeleteStop = () => {
            const li = event.target.parentNode;
            const parent = li.parentNode;
            const stopId = li.getAttribute('identity');
            const routeSelector = `#${parent.id}`;
            const request = new Greenmile.Route.TransferStops.Requests();
            const callback = () => {
              parent.removeChild(li);
              const filter = Monet.Session.TransferStops[parent.id].filter;
              request.getStopsAndAddToList(filter, routeSelector);
            };
            request.deleteStop(stopId, callback, routeSelector);
          };

          new Greenmile.Components.AlertModal('RouteMonitor.TransferStop.WantDeleteStop',
            null,
            confirmDeleteStop)
          .show();
          
        });
      }
    };

    this.getStopsToResequence = function (selector) {

        var stopsToTransfer = {},
            stop            = null;

        if (selector) {

            var stopsSelecteds = document.querySelectorAll(selector + " .selected");
            var countStops = stopsSelecteds.length;

            if (countStops > 0) {

                var arrayStops = [];

                var indexFirstElementSorted = $(stopsSelecteds[0]).index();

                stopsToTransfer.placementType = this.getPlacementType(indexFirstElementSorted);

                if (stopsToTransfer.placementType === "AFTER_STOP") {

                    stop = document.querySelector(selector + " li:nth-child(" + indexFirstElementSorted + ")");
                    stopsToTransfer.relatedStopId = stop.getAttribute("identity");

                }

                for (var i = 0; i < countStops; i++) {

                    stop = stopsSelecteds[i];

                    var originalPosition = stop.getAttribute("originposition");

                    var actualPosition = $(stop).index();

                    if (originalPosition !== actualPosition) {

                        var id = stop.getAttribute("identity");
                        arrayStops.push(id);
                    }

                }

                stopsToTransfer.stopIdList = arrayStops;

            }

            return stopsToTransfer;

        } else {

            var error = new Monet.Exception.ReturnError(this,
                "No selector to get stops.");
            error.console();

        }

    };

    this.getPlacementType = function (index) {
        var relatedStop = "FIRST";

        if (index >= 1) {
            relatedStop = "AFTER_STOP";
        }

        return relatedStop;

    };

    this.getOriginPositionOldLi = function (stop) {

        var dragOrigin = stop.getAttribute("originposition");
        var ol = stop.parentElement;
        var list = ol.querySelectorAll("li");

        for (var i = 1; i < list.length; i++) {

            var liOrigin = list[i].getAttribute("originposition");

            if (dragOrigin === liOrigin) {
                return list[i].getAttribute("identity");
            }
        }

    };

    this.getStopsAndResequence = function (selector, routeId, callback) {

        if (selector && routeId) {

            var request = new Greenmile.Route.TransferStops.Requests();
            request.resequenceStops(routeId, this.getStopsToResequence(selector), callback, selector);

        }

    };

    this.getDataAndTransferStops = function (receivedSelector, callback, bestInsertionSender) {

        try {

            var fromRoute = null;
            var toRoute = null;
            var transferStops;
            var targetRoute = receivedSelector;

            if (bestInsertionSender) {

                if (bestInsertionSender === "#stopsRouteSelected") {
                    targetRoute = "#stopsRouteFiltered";
                } else {
                    targetRoute = "#stopsRouteSelected";
                }

            }

            if (targetRoute === "#stopsRouteFiltered") {

                fromRoute = document.querySelector("#stopsRouteSelected").getAttribute("identity");
                toRoute = document.querySelector("#stopsRouteFiltered").getAttribute("identity");

            } else {

                fromRoute = document.querySelector("#stopsRouteFiltered").getAttribute("identity");
                toRoute = document.querySelector("#stopsRouteSelected").getAttribute("identity");

            }

            transferStops = this.getStopsToTransfer(receivedSelector);

            var request = new Greenmile.Route.TransferStops.Requests();
            request.transferStopsToRoute(fromRoute, toRoute, transferStops, callback, targetRoute);

        } catch (e) {

            var error = new Monet.Exception.ReturnError(this, "Problem on request transfer stops.");
            error.console();

        }

    };

    this.getStopsToTransfer = function (receivedSelector) {

        var error = null;

        try {

            var stopsToTransfer = null;
            var stopsSelecteds = document.querySelectorAll(receivedSelector + " .selected");
            var countStops = stopsSelecteds.length;

            if (countStops) {

                var arrayStops = [];
                var indexFirstElementSorted = 0;

                stopsToTransfer = {};

                if (receivedSelector === "#bestInsertion") {
                    stopsToTransfer.placementType = 'BEST_INSERTION';
                } else {
                    indexFirstElementSorted = $(stopsSelecteds[0]).index();
                    stopsToTransfer.placementType = this.getPlacementType(indexFirstElementSorted);
                }


                if (stopsToTransfer.placementType === "AFTER_STOP") {

                    var stop = document.querySelector(receivedSelector + " li:nth-child(" + indexFirstElementSorted + ")");

                    if (stop) {
                        stopsToTransfer.relatedStopId = stop.getAttribute("identity");
                    } else {
                        stop = document.querySelector(receivedSelector + " li");
                        stopsToTransfer.relatedStopId = this.getOriginPositionOldLi(stop);
                    }

                }

                for (var i = 0; i < countStops; i++) {

                    var id = stopsSelecteds[i].getAttribute("identity");
                    arrayStops.push(id);

                }

                stopsToTransfer.stopIdList = arrayStops;

            }

            return stopsToTransfer;

        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                "Problem on get stops to transfer.");
            error.console();

        }

    };

    this.enableBestInsertion = function () {

        $("#bestInsertion").sortable({
            over: function () {

                var bestInsertion = document.querySelector("#bestInsertion");
                bestInsertion.style.background = "#ccc";

            },
            out: function () {
                var bestInsertion = document.querySelector("#bestInsertion");
                bestInsertion.style.background = "";
            }
        });

        $("#bestInsertion").sortable("enable");

    };
};
